(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.accordion-header').forEach((header) => {
      if (header) {
        header.addEventListener('click', function () {
          const item = this.closest('.accordion-item');
          const body = item ? item.querySelector('.accordion-body') : null;

          if (!item || !body) return;

          const isOpen = item.classList.contains('open');

          document.querySelectorAll('.accordion-item').forEach((i) => {
            i.classList.remove('open');
            const accordionBody = i.querySelector('.accordion-body');
            if (accordionBody) {
              accordionBody.classList.add('hidden');
            }
          });

          if (!isOpen) {
            item.classList.add('open');
            body.classList.remove('hidden');
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // 🟡 Move this function to the top so it's accessible everywhere
    function isMobileView() {
      return window.innerWidth < 1024;
    }

    const body = document.body;
    const hamburgerIcon = document.querySelector('.hamburger-icon');
    const menuDrawer = document.getElementById('Details-menu-drawer-container');
    const scrollWrapper = document.getElementById('menu-scroll-wrapper');
    const mainTabs = document.getElementById('main-tabs');
    const featureLinks = document.querySelectorAll('.feature-links');
    const subtabsWrappers = document.querySelectorAll('.subtabs-wrapper');

    // Handle hamburger
    if (hamburgerIcon && menuDrawer) {
      hamburgerIcon.addEventListener('click', function () {
        menuDrawer.classList.toggle('open');
        hamburgerIcon.classList.toggle('open');
        body.classList.toggle('no-scroll-lock');
      });
    }

    // Default clothing selection
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    tabButtons.forEach((button) => {
      if (button) {
        button.addEventListener('click', () => {
          const selectedTab = button.dataset.tab;

          tabButtons.forEach((btn) => btn.classList.remove('active-tab'));
          button.classList.add('active-tab');

          tabContents.forEach((content) => {
            content.classList.toggle('hidden', content.id !== `tab-${selectedTab}`);
          });

          const selectedTabContent = document.getElementById(`tab-${selectedTab}`);
          const subtabButtons = selectedTabContent.querySelectorAll('.subtab-button');
          const subtabContents = selectedTabContent.querySelectorAll('.subtab-content');

          let clothingFound = false;

          subtabButtons.forEach((btn) => {
            const isClothing = btn.textContent.trim().toLowerCase() === 'clothing';
            btn.classList.remove('active-subtab');
            if (isClothing) {
              btn.classList.add('active-subtab');
              clothingFound = true;
            }
          });

          subtabContents.forEach((content) => {
            const isClothing = content.id.includes('clothing');
            content.classList.toggle('hidden', !isClothing);
          });

          if (!clothingFound && subtabButtons.length > 0) {
            subtabButtons[0].classList.add('active-subtab');
            subtabContents[0].classList.remove('hidden');
          }
        });
      }
    });

    // Sub-tab button toggle
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('subtab-button')) {
        const selectedSubtab = e.target.dataset.subtab;
        const currentTab = e.target.closest('.tab-content');

        if (currentTab) {
          const subtabButtons = currentTab.querySelectorAll('.subtab-button');
          const subtabContents = currentTab.querySelectorAll('.subtab-content');

          subtabButtons.forEach((btn) => btn.classList.remove('active-subtab'));
          e.target.classList.add('active-subtab');

          subtabContents.forEach((content) => {
            content.classList.toggle('hidden', content.id !== `subtab-${selectedSubtab}`);
          });
        }
      }
    });

    // 👉 Touch-based scroll detection
    let touchStartY = 0;
    let touchEndY = 0;

    if (scrollWrapper && isMobileView()) {
      scrollWrapper.addEventListener('touchstart', function (e) {
        touchStartY = e.touches[0].clientY;
      });

      scrollWrapper.addEventListener('touchmove', function (e) {
        if (!menuDrawer.classList.contains('open')) return;

        touchEndY = e.touches[0].clientY;
        const deltaY = touchEndY - touchStartY;

        // Swipe up
        if (deltaY < -50) {
          mainTabs?.classList.add('hide-on-scroll');
          featureLinks.forEach((el) => el.classList.add('hide-on-scroll'));
          subtabsWrappers.forEach((el) => el.classList.add('subtabs-slide-up'));
        }

        // Swipe down
        if (deltaY > 50) {
          mainTabs?.classList.remove('hide-on-scroll');
          featureLinks.forEach((el) => el.classList.remove('hide-on-scroll'));
          subtabsWrappers.forEach((el) => el.classList.remove('subtabs-slide-up'));
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
